<template>
  <div>
    <nav-top Title="卡密地址"></nav-top>
    <van-cell-group>
      <van-cell title="京东地址-50元沃尔玛山姆卡" is-link to="https://item.jd.com/10112823761915.html " icon="debit-pay"/>
      <van-cell title="淘宝地址-100元沃尔玛山姆卡" is-link to="https://item.taobao.com/item.htm?id=831075172279" icon="after-sale"/>
      <van-cell title="淘宝地址-100元沃尔玛山姆卡-备用" is-link to="https://item.taobao.com/item.htm?id=895778369032" icon="orders-o"/>
      <van-cell title="淘宝地址-200元沃尔玛山姆卡" is-link to="https://item.taobao.com/item.htm?id=901047644741" icon="todo-list-o"/>
      <van-cell title="淘宝地址-200元沃尔玛山姆卡-备用" is-link to="https://item.taobao.com/item.htm?id=903237461500" icon="todo-list-o"/>
      <van-cell title="淘宝地址-500元沃尔玛山姆卡" is-link to="https://item.taobao.com/item.htm?id=893920246530" icon="todo-list-o"/>
    </van-cell-group>
    <div style="display: flex; flex-direction: column; align-items: center; margin-top: 3vw;padding: 3vw;">
      <van-highlight :keywords="keywords" source-string="淘宝购买注意事项: 认准23和60开头的沃尔玛山姆通用的卡" highlight-class="custom-class" />
      <p style="margin-top: 3vw;">拼多多购买: 拼多多搜沃尔玛电子卡， 看到下图这样子的都可以购买---拼多多可以买到50面值的卡</p>
      <img :src=wallMart alt="" style="width: 60vw">
    </div>
  </div>
</template>

<script>
import NavTop from "@/components/common/NavTop";

export default {
  name: "userCard",
  components:{
    NavTop,
  },
  data(){
    return {
      keywords:['23','60', '沃尔玛山姆'],
      wallMart:require("@/assets/wallMart.jpg")
    }
  }
}
</script>

<style scoped lang="scss">
.custom-class{
  color: red;
}
</style>
